import { styled } from '@mui/system';
import BottomNavigation from '@mui/material/BottomNavigation';

import { getPageBackgroundColor } from 'styles/helpers/getThemeStyles';

export const StyledBottomNavigation = styled(BottomNavigation)(({ theme }) => {
  return {
    backgroundColor: getPageBackgroundColor(theme)
  };
});
